import React from "react";

export default function LoadingScreen() {
  return (
    <div
      className="fixed inset-0 flex flex-col justify-center items-center bg-[#978b72] z-50"
      style={{
        animation: "fadeOut 0.5s ease-in-out 2.5s forwards",
      }}
    >
      <h1 className="text-white text-2xl md:text-6xl font-bold tracking-widest"
      style={{ animation: "dropDown 1s ease-out forwards" }}
      >
        Mandla Mbolekwa
        </h1>

      <div className="mt-8 w-[50%] h-[2px] bg-white/20 rounded-full  overflow-hidden">
        <div
          className="h-full bg-white rounded-full"
          style={{ animation: "fillBar 2.5s linear forwards" }}
        />

        
      </div>
      <p
          className="text-[#1c143f]/80 text-sm mt-4 tracking-[0.3em] uppercase"
          style={{ animation: "fadeInUp 1s ease-out 0.5s both" }}
        >
          Software Developer
        </p>
    </div>
  );
}
